import React from 'react'
import Footer from './Footer'

function Hoteldeals() {
    return (
        <div className="hoteldeals">
            <div className="deals_img">
                <img src="assets/hotel lobby.webp" alt="hotel" />
            </div>
            <div className="overlay_home"></div>
            <div className="centerform_container">
                <div className="centerform">

                    <div className="innerform">
                    <h2>Find Meeting Space</h2>

                    <form action="">
                        <div className="form_content">
                            <label htmlFor="destination">Destination: </label>
                            <input type="text" className='content_input' placeholder='Where do you want to be near'/>
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">Event Start date: </label>
                            <input type="date" name="start_date" /> <span>To</span>
                           <input type="date" name="date_end"   />
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">Room Layout: </label>
                            <input type="number" name="" className='content_input' placeholder="Banquet - 5' Tables(8 per)"/>
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">No. of people: </label>
                            <input type="text" className='content_input_small' />
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">Rental period: </label>
                            <input type="number" className='content_input' placeholder='Half day rental(4 hours)'/>
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">No. of bedrooms: </label>
                            <input type="number" className='content_input_small' placeholder='0'/>
                        </div>
                        <div className="form_content">
                            <label htmlFor="destination">Min. room size: </label>
                            <input type="text"  />
                            <input type="number" name=""   placeholder="Sq.feet" />
                        </div>
                        <div className="advanced_search">
                            <span>+</span>
                            <p>advanced search</p>
                        </div>
                        <div className="form_contentRadio">
                        <div className="form_content">
                            <input type="radio" name="" id="view" />
                            <label htmlFor="destination">View results in a list </label>
                        </div>
                        
                        <div className="form_content">
                            <input type="radio" name="" id="view" />
                            <label htmlFor="destination">View results on a map </label>
                        </div>
                        </div>
                        <div className="button_submit">
                          <input type="button" value="Search Spaces" />
                        </div>
                    </form>
                    </div>
                    <div className="form_ruler"></div>

                    <div className="side_contents">
                        <div className="side_uppercontent">
                            <img src="assets/floor plan.jpg" alt="floor plan" />
                            <p>Room Layout View</p>
                        </div>
                        <div className="side_lowercontent">
                            <h2>Need to book bedrooms?</h2>
                            <p>Submit a request to receive hotel bids for your event</p>
                           <a  href="https://www.softwaredevbytes.com">Group hotel rates</a>
                        </div>
                    </div>
                 
                </div>
            </div>
            
            <div className="hoteldeals_subsection">
                <div className="subsection_container">
                    <div className="subsection_content">
                        <h2>Find Meeting space, search for large event space for rent</h2>
                        <p>
                        Use the search box above to find hotel meeting spaces,
                         event space pricing and book function venues. We also have
                          advanced search options to allow you to filter results by
                           price (i.e. luxury hotels vs. cheap hotels) and star rating.
                            You can use the hotel map feature to view the hotels on a map along with the rates.
                        </p>
                    </div>
                   
                    {/* </div>
                    <div className="subsection_container"> */}
                   
                    <div className="subsection_content">
                        <h2>Your assigned hotel catering contact</h2>
                        <p>
                        To meet your contact, refer to your account for incoming responses from interested hotels
                         and venues. When you receive an offer that interests you, click the "accept bid" button
                          and contact information will be exchanged. You will often be corresponding with a Catering 
                          or Event Manager. This is the person who will see you through your special event.Our clients
                           are entitled to exceptional service and wonderful memories. If you have questions, need advice 
                           or have feedback about any phase of your event planning process please contact us. We look forward
                            to making your event a success.
                        </p>
                    </div>
                    <div className="subsection_content">
                        <h2>How will I feed my guests?</h2>
                        <p>
                        In regards to a social event, especially if this is your first time planning something of this 
                        magnitude, there can be a lot of questions. You may wonder what food to order, and how much? 
                        If drinks will be served, should you offer a hosted bar, pay on consumption or offer drinks vouchers?
                         What time of day do you want the event to start? What is the parking situation: does the location offer
                          self-parking, valet parking, or both, and what are the costs? You may not foresee needing audiovisual
                        equipment, but it can be a nice and memorable touch for social events to play videos and slideshows of
                        those being honoured, or create a visual recap over a period of time with accompanying music.
                        If you have a budget in mind, many venues can alter/customise their menus and services to help align
                        themselves with your financial needs. Your contact at each venue should be able to guide and help you 
                        through this entire process, making it a fun and enjoyable experience with a gratifying and memorable outcome.
                        </p>
                    </div>
                    <div className="subsection_content">
                        <h2>Factor in local taxes and fees</h2>
                        <p>
                        Be sure to also leave room in your budget for applicable taxes and fees. Such additional
                         charges can apply to space rental, food and drinks, audiovisual, guestrooms and other 
                         services. Taxes will vary by geographic location. Service charges are very common, as 
                         they relate to the people who set-up, serve and execute the event. When reviewing menus
                          for sit-down meals, the pricing is often listed as "exclusive", meaning exclusive of tax
                        and service. Prices will often be described as x amount per person, "plus plus"; or plus
                        tax, plus service (meal price x multiplied by 1.percentage of tax multiplied by 1.percentage of service).
                        It is not possible to anticipate all taxes, fees and charges on a general scale as they vary
                        by hotel/venue and event specifics. When you begin corresponding with the hotels and venues
                        which interest you for your event, be sure to ask them to outline any and all taxes, fees and charges.
                        Viewing a total price will not only make you more comfortable that there won't be any surprises on
                        your bill, but will also be helpful when deciding between options.
                        </p>
                    </div>
                    <div className="subsection_content">
                        <h2>Planning a wedding, get-together or another special event?</h2>
                        <p>
                        Are you coordinating a wedding, family get-together, sports tournament,
                         awards event, incentive trip, hospitality area, or other special event? 
                         Our meeting space portal will enable you to explore the possibilities at
                          over 50,000 hotels and venues worldwide. We are confident you will find 
                          the ideal fit for your function, whatever it may be. By filling in the fields
                           above, your event specifications will be sent to all of our hotel and venue 
                           partners in your selected location(s) (up to eight destinations may be searched
                            at one time) and they will respond with offers and availability for your event. 
                          You are able to use "Advanced filters" to view your responses sorted by price or
                          star rating of the hotel or venue. By clicking on the "Hotel map" tab, you can
                          compare the distance of your potential event sites to any other locations you
                          may be visiting over those dates (i.e. fields for sports tournaments, churches 
                          or weddings and parks for family get-togethers).There will often be a charge
                          for the use of space for your event called "meeting room/function space rental".
                          This rental charge can sometimes be negotiated depending upon food and drinks,
                          audiovisual, and/or guestroom guarantees. For instance, if you are searching a
                          venue for a wedding, the space used for the ceremony and wedding breakfast may 
                          be discounted or provided free-of-charge, depending upon your food and drinks spend.
                          If you have your sights set on a particular hotel or venue, being flexible with your
                          dates can help them find a spot in their function book to give you the space that you want.
                        </p>
                    </div>
                    
                </div>
               
            </div>
            <Footer />

        </div>
    )
}

export default Hoteldeals
